module.exports = __webpack_public_path__ + "static/media/origin-properties.cd8b7e13.svg";